import { fromJS } from 'immutable';
import * as types from '../constants';

const defaultState = fromJS({
  status: false,
  qvBgColor: '#FFFFFF',
  qvTextColor: '#000000',
  qvTextPriceColor: '#111111',
  qvBgPriceColor: '#0089ff',

  addToCartBtnText: 'Add to cart',
  addedToCartBtnText: 'Added to cart',
  whenSoldOutBtnText: 'Sorry! This item is sold out.',
  addToCartBtnBgColor: '#ffffff',
  addToCartBtnTextColor: '#666666',
  addToCartBtnBorderColor: '#666666',
  addToCartHvBtnBgColor: '#ffffff',
  addToCartHvBtnTextColor: '#666666',
  addToCartHvBtnBorderColor: '#666666',
  addToCartLoadingColor: '#919eab',

  buyNowBtnTex: 'BUY IT NOW',
  buyNowWhenSoldOutBtnText: 'Sorry! This item is sold out.',
  buyNowBtnBgColor: '#ff9b04',
  buyNowBtnTextColor: '#ffffff',
  buyNowBtnBorderColor: '#ff9b04',
  buyNowBtnHvBgColor: '#ff9b04',
  buyNowBtnHvTextColor: '#ffffff',
  buyNowBtnHvBorderColor: '#ff9b04',
  buyNowLoadingColor: '#919eab',

  chooseDetailOption: 'show',
  lessDetailTitle: 'Full Product Details',
  fullDetailTitle: 'Full Product Details',
  lessDetailColor: '#0089ff',
  lessDetailHoverColor: '#004D95',
  fullDetailHoverColor: '#004D95',
  fullDetailColor: '#0089ff',

  getSettingLoading: true,
  saveSettingLoading: false,
  saveSettingResult: 0
});

let res = '';

const quickViewReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.CHANGE_QUICK_VIEW_FIELD:
      res = action.payload;
      return state.set(res.field, res.value);

    case types.GET_SETTING_QUICK_VIEW:
      return state.set('getSettingLoading', true);
    case types.GET_SETTING_QUICK_VIEW_RESULT:
      res = action.res;
      if (res) {
        return state
          .set('status', res.qv_status)
          .set('qvBgColor', res.qv_bg_color)
          .set('qvTextColor', res.qv_text_color)
          .set('qvTextPriceColor', res.qv_text_price_color)
          .set('qvBgPriceColor', res.qv_bg_price_color)
          .set('addToCartBtnText', res.add_to_cart_btn_text)
          .set('addedToCartBtnText', res.added_to_cart_btn_text)
          .set('whenSoldOutBtnText', res.when_sold_out_btn_text)
          .set('addToCartBtnBgColor', res.add_to_cart_btn_bg_color)
          .set('addToCartBtnTextColor', res.add_to_cart_btn_text_color)
          .set('addToCartBtnBorderColor', res.add_to_cart_btn_border_color)
          .set('addToCartHvBtnBgColor', res.add_to_cart_hv_btn_bg_color)
          .set('addToCartHvBtnTextColor', res.add_to_cart_hv_btn_text_color)
          .set('addToCartHvBtnBorderColor', res.add_to_cart_hv_btn_border_color)
          .set('addToCartLoadingColor', res.add_to_cart_loading_color)
          .set('buyNowBtnTex', res.buy_now_btn_tex)
          .set('buyNowWhenSoldOutBtnText', res.buy_now_when_sold_out_btn_text)
          .set('buyNowBtnBgColor', res.buy_now_btn_bg_color)
          .set('buyNowBtnTextColor', res.buy_now_btn_text_color)
          .set('buyNowBtnBorderColor', res.buy_now_btn_border_color)
          .set('buyNowBtnHvBgColor', res.buy_now_btn_hv_bg_color)
          .set('buyNowBtnHvTextColor', res.buy_now_btn_hv_text_color)
          .set('buyNowBtnHvBorderColor', res.buy_now_btn_hv_border_color)
          .set('buyNowLoadingColor', res.buy_now_loading_color)
          .set('chooseDetailOption', res.choose_detail_option)
          .set('lessDetailTitle', res.less_detail_title)
          .set('fullDetailTitle', res.full_detail_title)
          .set('lessDetailColor', res.less_detail_color)
          .set('lessDetailHoverColor', res.less_detail_hover_color)
          .set('fullDetailHoverColor', res.full_detail_hover_color)
          .set('fullDetailColor', res.full_detail_color)

          .set('getSettingLoading', false);
      }
      return state.set('getSettingLoading', false);

    case types.SAVE_SETTING_QUICK_VIEW:
      return state.set('saveSettingLoading', true).set('saveSettingResult', 0);
    case types.SAVE_SETTING_QUICK_VIEW_RESULT:
      return state.set('saveSettingLoading', false).set('saveSettingResult', action.res);

    case types.CLEAR_DATA_QUICK_VIEW:
      return state.set('getSettingLoading', true).set('saveSettingResult', 0);
    default:
      return state;
  }
};

export default quickViewReducer;
